import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <ellipse cx="32" cy="32" rx="21" ry="27" transform="rotate(-16 32 32)" fill="none" stroke="#D7263D" strokeWidth="1.6" />
    <g fill="none" stroke="#0E1B3D" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 19v26M19 33l12-14M23 29l9 16" />
      <path d="M36 45V19h6a7 7 0 0 1 0 14h-6M41 33l7 12" />
    </g>
  </svg>
);

export const Logo = ({ to = "/" }) => (
  <Link to={to} data-testid="brand-logo-link" className="group flex items-center gap-3">
    <LogoMark className="w-9 h-9 transition-transform duration-700 group-hover:rotate-[16deg]" />
    <span className="leading-none">
      <span className="block font-display text-lg tracking-wide text-[#0E1B3D]">Katie Razenski</span>
    </span>
  </Link>
);
